/**
 * Speaker ID (e.g., "SPEAKER_00", "SPEAKER-01")를 "화자 1", "화자 2" 형식으로 변환합니다.
 * @param speakerId 변환할 스피커 ID
 * @returns "화자 {번호}" 형식의 문자열
 */
export const formatSpeakerName = (speakerId: string): string => {
  // "SPEAKER-" 또는 "SPEAKER_" 부분을 대소문자 구분 없이 제거하여 숫자 부분만 추출합니다.
  const speakerNumberStr = speakerId.replace(/SPEAKER[-_]/i, "");
  const speakerNumber = parseInt(speakerNumberStr, 10);

  // 숫자로 변환할 수 없는 경우, 원래 ID를 반환합니다.
  if (isNaN(speakerNumber)) {
    return speakerId;
  }

  // 1을 더하여 "화자 1", "화자 2" 등으로 만듭니다.
  return `화자 ${speakerNumber + 1}`;
};
